var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIAvnOrders = function SvgIAvnOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    cx: 1,
    cy: 1,
    fill: "#002774",
    "data-no-stroke": "true"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    cx: 1,
    cy: 6,
    fill: "#002774",
    "data-no-stroke": "true"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    cx: 1,
    cy: 11,
    fill: "#002774",
    "data-no-stroke": "true"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1h8M4 6h8M4 11h8",
    stroke: "#002774",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    "data-no-fill": "true"
  })));
};
export { SvgIAvnOrders as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTMgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIHI9IjEiIGN4PSIxIiBjeT0iMSIgZmlsbD0iIzAwMjc3NCIgZGF0YS1uby1zdHJva2U9InRydWUiLz4KICAgIDxjaXJjbGUgcj0iMSIgY3g9IjEiIGN5PSI2IiBmaWxsPSIjMDAyNzc0IiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgogICAgPGNpcmNsZSByPSIxIiBjeD0iMSIgY3k9IjExIiBmaWxsPSIjMDAyNzc0IiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgogICAgPHBhdGggZD0iTTQgMUgxMiIgc3Ryb2tlPSIjMDAyNzc0IiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDxwYXRoIGQ9Ik00IDZIMTIiIHN0cm9rZT0iIzAwMjc3NCIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZGF0YS1uby1maWxsPSJ0cnVlIi8+CiAgICA8cGF0aCBkPSJNNCAxMUgxMiIgc3Ryb2tlPSIjMDAyNzc0IiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KPC9zdmc+Cg==";